import * as Yup from "yup";
import {
  noSpecialCharsYupTest,
  SPECIAL_CHARS_VALIDATION_MESSAGE,
} from "../utils/inputValidation";

export const addGroupSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest
    )
    .required("Group name is required")
    .min(2, "Group name must be at least 2 characters")
    .max(50, "Group name cannot exceed 50 characters"),
  description: Yup.string()
    .trim()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest
    )
    .max(500, "Description cannot exceed 500 characters"),
});

export const editGroupSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest
    )
    .required("Group name is required")
    .min(2, "Group name must be at least 2 characters")
    .max(50, "Group name cannot exceed 50 characters"),
  description: Yup.string()
    .trim()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest
    )
    .max(500, "Description cannot exceed 500 characters"),
});
